<p>Enter an order number below to start tracking!</p>
<form (ngSubmit)="navigateToOrder()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input matInput placeholder="Order ID" name="orderId" [(ngModel)]="orderId" />
  </mat-form-field>
  <button mat-flat-button type="submit">Track Shipment</button>
</form>
<router-outlet />
